import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { getTemplateDisplayName, TrussDesignDrawingTemplates } from '@paragon/client-tools';

interface ChooseTrussDesignDrawingTemplatesProps {
  readonly templates: TrussDesignDrawingTemplates;
  readonly selectedTrussDesignDrawingTemplateId: number | null;
  readonly setSelectedTrussDesignDrawingTemplateId: (id: number) => void;
  readonly selectedTrussDesignDrawingOverflowTemplateId: number | null;
  readonly setSelectedTrussDesignDrawingOverflowTemplateId: (id: number) => void;
  readonly type: 'standard' | 'repair';
}

export function ChooseTrussDesignDrawingTemplates({
  templates,
  selectedTrussDesignDrawingTemplateId,
  setSelectedTrussDesignDrawingTemplateId,
  selectedTrussDesignDrawingOverflowTemplateId,
  setSelectedTrussDesignDrawingOverflowTemplateId,
  type,
}: ChooseTrussDesignDrawingTemplatesProps) {
  const templateOptions =
    type === 'repair' ? templates.repairTrussDesignDrawingTemplates : templates.trussDesignDrawingTemplates;
  const overflowTemplateOptions = templates.trussDesignDrawingOverflowTemplates;
  const templateSelectionLabel = type === 'repair' ? 'Template' : 'Template for first pages';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px', maxWidth: '100%' }}>
      <FormControl sx={{ my: 2 }}>
        <InputLabel id="select-truss-design-drawing-template">{templateSelectionLabel}</InputLabel>
        <Select<number>
          labelId="select-truss-design-drawing-template"
          fullWidth
          value={selectedTrussDesignDrawingTemplateId ?? ''}
          onChange={(event) => setSelectedTrussDesignDrawingTemplateId(event.target.value as number)}
          disabled={(templateOptions?.length ?? 0) <= 1}
          label={templateSelectionLabel}
        >
          {templateOptions?.map((template) => (
            <MenuItem value={template.id} key={template.id}>
              {getTemplateDisplayName(template)}
            </MenuItem>
          )) ?? null}
        </Select>
      </FormControl>
      {type !== 'repair' && (
        <FormControl sx={{ my: 2 }}>
          <InputLabel id="select-truss-design-drawing-overflow-template">Template for additional pages</InputLabel>
          <Select<number>
            labelId="select-truss-design-drawing-overflow-template"
            fullWidth
            value={selectedTrussDesignDrawingOverflowTemplateId ?? ''}
            onChange={(event) => setSelectedTrussDesignDrawingOverflowTemplateId(event.target.value as number)}
            disabled={(overflowTemplateOptions?.length ?? 0) <= 1}
            label="Template for additional pages"
          >
            {overflowTemplateOptions?.map((template) => (
              <MenuItem value={template.id} key={template.id}>
                {getTemplateDisplayName(template)}
              </MenuItem>
            )) ?? null}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}
